import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { extendObservable } from 'mobx'

import { segmentApi } from '@atheneum/api'

import '../Sidebar.sass'

class SegmentSidebar extends Component {
  static propTypes = {
    id: PropTypes.number
  }

  constructor (props) {
    super(props)

    extendObservable(this, { segment: null })
    segmentApi.getOne(this.props.id).then(segment => {
      this.segment = segment
      if (this.segment.screeningQuestionsOrder) {
        const reorderedQuestions = this.segment.screeningQuestionsOrder
          .split(', ')
          .map(id => {
            return {
              id,
              question: this.segment.screeningQuestions.find(
                q => q.id === Number(id)
              ).question
            }
          })
        this.segment.screeningQuestions.replace(reorderedQuestions)
      }
    })
  }

  render () {
    if (!this.segment) return null
    return (
      <div>
        <h1>{this.segment.name}</h1>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            No. of experts required
          </span>
          <p>{this.segment.numberOfExpert}</p>
        </div>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Assigned associates
          </span>
          <p>
            {this.segment.employees.map(e => (
              <div key={e.id}>{e.fullName}</div>
            ))}
          </p>
        </div>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Expert brief
          </span>
          <p
            dangerouslySetInnerHTML={{
              __html: this.segment.expertBrief
            }}
          />
        </div>

        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Screening questions
          </span>
          {this.segment.screeningQuestions.map(({ question }) => (
            <p
              dangerouslySetInnerHTML={{ __html: question }}
              className='m-b-xl'
            />
          ))}
        </div>
      </div>
    )
  }
}

export default observer(SegmentSidebar)
